module.exports = __webpack_public_path__ + "static/img/1.b2baf39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/1.png
// module id = TLtR
// module chunks = 0